import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const BusyButton = ({
    loading,
    children,
    disabled,
    variant = "primary",
    size = "sm",
    icon = faCircleNotch,
    ...otherProps
}) => {
    const spinnerSize = () => {
        switch (size) {
            case "sm":
                return "1.2rem";
            case "lg":
                return "2.2rem"
            default:
                return "2.2rem";
        }
    };

    return (
        <Button variant={variant} size={size === "sm" || size === "lg" ? size : ""} disabled={disabled || loading} {...otherProps}>
            <div style={{ position: "relative" }}>
                <div
                    className={`busy-container ${loading ? "busy-container-active" : ""}`}
                >
                    <FontAwesomeIcon style={{ fontSize: spinnerSize() }} icon={icon} spin />
                </div>
                <div className={loading ? "busy-button-active" : ""}>{children}</div>
            </div>
        </Button>
    );
};

export default BusyButton;